<!-- 物业通知 -->
<style lang="scss" scoped>
.com-not {
  position: absolute;
  width: 415px;
  height: 673px;
  top: 135px;
  right: 45px;
}
</style>
<template>
  <div class="com-not common-bg">
    <community-notification></community-notification>
  </div>
</template>

<script>
import CommunityNotification from "./components/community-notification.vue";
export default {
  components: {
    CommunityNotification,
  },
};
</script>
